module.exports = __webpack_public_path__ + "img/placeholder.f43cbce9.webp";